/**
 * Three-tile activity comparison row used on Dashboard + Analytics.
 * Shows the same metric across:
 *  · This FY (sky)
 *  · Past 5 FYs (indigo)
 *  · All time (grey)
 * so Jamie can eyeball recent vs long-term performance on one screen.
 */
export default function ThreeWindowRow({
  title,
  fyLabel,
  past5Label,
  fyValue,
  past5Value,
  allValue,
  fyHint,
  past5Hint,
  allHint,
  testid,
}) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid={`${testid}-row`}>
      <div className="border border-sky-200 rounded-md p-4 bg-sky-50" data-testid={`${testid}-fy`}>
        <p className="text-xs text-sky-800 uppercase tracking-wide mb-1">{title} — FY {fyLabel || ""}</p>
        <p className="font-heading font-bold text-2xl text-sky-700">{fyValue || 0}</p>
        <p className="text-[11px] text-sky-600 mt-0.5">{fyHint}</p>
      </div>
      <div className="border border-indigo-200 rounded-md p-4 bg-indigo-50" data-testid={`${testid}-past5`}>
        <p className="text-xs text-indigo-800 uppercase tracking-wide mb-1">{title} — Past 5 FYs</p>
        <p className="font-heading font-bold text-2xl text-indigo-700">{past5Value || 0}</p>
        <p className="text-[11px] text-indigo-600 mt-0.5">{past5Label ? `${past5Label} · ${past5Hint}` : past5Hint}</p>
      </div>
      <div className="border border-border rounded-md p-4 bg-white" data-testid={`${testid}-all`}>
        <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">{title} — All time</p>
        <p className="font-heading font-bold text-2xl">{allValue || 0}</p>
        <p className="text-[11px] text-muted-foreground mt-0.5">{allHint}</p>
      </div>
    </div>
  );
}
